import React from 'react';
import { getWebpSrc } from '../../utils/imageFormats';
import { getPortfolioImageAlt } from '../../utils/imageAltText';

export const ImageGrid = ({ filteredImages, setSelectedImage }) => {
  const categoryLabel = category => {
    const labels = {
      equine: 'Equine',
      'black-background': 'Black Background',
      couples: 'Couples',
      weddings: 'Weddings',
      family: 'Family',
      senior: 'Senior',
      prom: 'Prom',
      pets: 'Pets'
    };

    return labels[category] || category;
  };

  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
      {filteredImages.map((image, index) => {
        const imageLabel = image.title || getPortfolioImageAlt(image) || 'portfolio image';

        return (
          <button
          key={image.id}
          type="button"
          onClick={() => setSelectedImage(image)}
          aria-label={`Open ${imageLabel} in gallery modal`}
          className="group relative overflow-hidden rounded-2xl bg-white/50 text-left shadow-lg transition-all duration-300 hover:scale-105 hover:shadow-2xl focus-visible:ring-2 focus-visible:ring-cyan-500 focus-visible:ring-offset-2 motion-reduce:transition-none motion-reduce:hover:scale-100"
          style={{ animationDelay: `${index * 0.1}s` }}
        >
          <picture>
            <source srcSet={getWebpSrc(image.src)} type="image/webp" />
            <img
              src={image.src}
              alt={getPortfolioImageAlt(image)}
              loading={index < 3 ? 'eager' : 'lazy'}
              fetchPriority={index < 3 ? 'high' : 'low'}
              decoding="async"
              width="1600"
              height="1067"
              sizes="(min-width: 1024px) 33vw, (min-width: 768px) 50vw, 100vw"
              className="h-64 w-full object-cover transition-transform duration-500 group-hover:scale-110 motion-reduce:transition-none motion-reduce:group-hover:scale-100"
            />
          </picture>

          <div className="absolute inset-0 bg-gradient-to-t from-teal-900/70 via-cyan-900/20 to-transparent opacity-0 transition-all duration-300 group-hover:opacity-100 motion-reduce:transition-none motion-reduce:opacity-100" />

          <div className="absolute bottom-0 left-0 right-0 translate-y-full p-4 text-white transition-transform duration-300 group-hover:translate-y-0 group-focus-visible:translate-y-0 motion-reduce:translate-y-0 motion-reduce:transition-none">
            <p className="text-sm font-semibold uppercase tracking-wide text-gray-100">
              {categoryLabel(image.category)}
            </p>
          </div>
          </button>
        );
      })}
    </div>
  );
};
